import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeedColumnLookup } from './models/feed-column-lookup.model';


@Injectable()
export class FeedColumnLookupService {

    constructor() { }

    get(feedName: string, fieldName: string): Observable<FeedColumnLookup> {
        return Observable.empty<FeedColumnLookup>();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-column-lookup.service.ts